import { render, staticRenderFns } from "./RobotCenter.vue?vue&type=template&id=4ce3fd7e&scoped=true&"
import script from "./RobotCenter.vue?vue&type=script&lang=js&"
export * from "./RobotCenter.vue?vue&type=script&lang=js&"
import style0 from "./RobotCenter.vue?vue&type=style&index=0&id=4ce3fd7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce3fd7e",
  null
  
)

export default component.exports